import ClickToVoiceCallContent from './clickToVoiceCallContent';

const clickToVoiceCall = {
  name: 'Click to Voice Call',
  Content: ClickToVoiceCallContent,
  setInitialContent: (content = {}) => {
    return {
      connectionId: content.connectionId || '',
      sourcePhoneNumber: content.sourcePhoneNumber || '',
      destinationPhoneNumber: content.destinationPhoneNumber || ''
    };
  },
  valid: content => {
    return Boolean(
      content.connectionId &&
      content.sourcePhoneNumber &&
      content.destinationPhoneNumber
    );
  }
};

export default clickToVoiceCall;
